import "../../chunk-7QVYU63E.js";
import { InvoiceStatus, PlanContractType, Subscription_SubscriptionStatus } from "@alch/protobufs-es/billing/billing_core_pb";
import z from "zod";
const BillingAddress = z.object({
  line1: z.string().nonempty(),
  line2: z.string(),
  city: z.string().nonempty(),
  state: z.string(),
  postalCode: z.string().nonempty(),
  country: z.string().nonempty()
});
const TaxId = z.object({
  country: z.string(),
  type: z.string(),
  value: z.string()
});
const PublicInvoiceStatus = z.nativeEnum({
  ISSUED: InvoiceStatus.ISSUED,
  PAID: InvoiceStatus.PAID,
  PAYMENT_FAILED: InvoiceStatus.PAYMENT_FAILED
});
const SubscriptionStatus = Subscription_SubscriptionStatus;
const SubscriptionPlanContractType = PlanContractType;
export {
  BillingAddress,
  PublicInvoiceStatus,
  SubscriptionPlanContractType,
  SubscriptionStatus,
  TaxId
};
//# sourceMappingURL=billing.js.map